import React from 'react';
import RemoveFromScheduleIcon from '@mui/icons-material/ContentPasteOff';
import EditIcon from '@mui/icons-material/Edit';

import { TooltipIconButton } from '@paragon/client-tools';

import { showEditScheduleGroupDialog } from '../../../actions/dialogActions';
import { removeBundleFromScheduleGroup } from '../../../actions/scheduleGroupActions';
import { getStatusesByBundleGuid } from '../../../selectors/bundles';
import { GridRow } from '../../../selectors/scheduleGroupGrid';
import { useAppDispatch, useAppSelector } from '../../hooks';

const buttonSx = { height: 20, width: 20, ml: 0.5, mr: 0.5 };

interface ScheduleGroupGridRowActionsProps {
  row: GridRow;
}

export function ScheduleGridRowActions(props: ScheduleGroupGridRowActionsProps) {
  const dispatch = useAppDispatch();
  const bundles = useAppSelector((state) => state.bundles);
  const statusesByBundleGuid = useAppSelector(getStatusesByBundleGuid);

  const {
    row: { guid, type },
  } = props;

  function removingIsAllowedForBundleRow() {
    const { row } = props;
    if (row.type !== 'bundle') return false;

    if (statusesByBundleGuid[guid].some((status) => status !== 'Unscheduled')) return false;

    // If the bundle is part of a Schedule Line Group it cannot be removed
    const { scheduleLineGroupGuid, truckloadGuid } = bundles[guid];
    if (scheduleLineGroupGuid !== null || truckloadGuid !== null) return false;

    return true;
  }

  return (
    <>
      {type === 'scheduleGroup' && (
        <TooltipIconButton
          title="Edit schedule group"
          sx={buttonSx}
          onClick={(event) => {
            event.stopPropagation();
            dispatch(showEditScheduleGroupDialog(guid));
          }}
        >
          <EditIcon />
        </TooltipIconButton>
      )}
      {type === 'bundle' && (
        <TooltipIconButton
          title={
            removingIsAllowedForBundleRow()
              ? 'Remove from the schedule group'
              : 'You can only remove a bundle from the schedule group if its status is "Unscheduled" and it is not part of a truckload'
          }
          sx={buttonSx}
          onClick={(event) => {
            event.stopPropagation();
            dispatch(removeBundleFromScheduleGroup(guid));
          }}
          disabled={!removingIsAllowedForBundleRow()}
        >
          <RemoveFromScheduleIcon />
        </TooltipIconButton>
      )}
    </>
  );
}
